module.exports = __webpack_public_path__ + "static/media/linksight_visual_small.4687547c.svg";